import { useEffect, useState } from "react";
import { ShoppingList } from "../types/ShoppingList";

export function useIsOnShoppingList(
    bettyBundleId: string | null | undefined,
    shoppingLists: ShoppingList[] | null | undefined
) {
    const isOnEitherShoppingList = () => {
        if (shoppingLists && bettyBundleId) {
            for (const list of shoppingLists) {
                if (list?.items?.find((bundle) => bundle.bettyBundleId === bettyBundleId)) {
                    return true;
                }
            }
        }
        return false;
    };

    const [isOnShoppingList, setIsOnShoppingList] = useState(isOnEitherShoppingList());

    useEffect(() => {
        setIsOnShoppingList(isOnEitherShoppingList());
    }, [bettyBundleId, shoppingLists]);

    return {
        isOnShoppingList
    };
}
